module.exports = {"211282001":"新城街道","211282002":"老城街道","211282003":"兴开街道","211282102":"威远堡镇","211282103":"庆云堡镇","211282104":"中固镇","211282105":"八棵树镇","211282106":"金沟子镇","211282107":"八宝镇","211282108":"业民镇","211282109":"莲花镇","211282110":"靠山镇","211282111":"马家寨镇","211282112":"下肥镇","211282113":"松山镇","211282114":"城东镇","211282115":"李家台镇","211282116":"上肥地满族镇","211282117":"黄旗寨满族镇","211282217":"林丰满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211282.json
// module id = 589
// module chunks = 0